import { Check, LockKeyhole, Shirt, Sparkles, X } from 'lucide-react'
import { outfitConfigs, type OutfitType } from '@/data/outfitConfig'
import { useOutfitState } from '@/store/selectors'
import './floatingAssistant.css'

interface WardrobeModalProps {
  onClose: () => void
}

export default function WardrobeModal({ onClose }: WardrobeModalProps) {
  const { currentOutfit, ownedOutfits, stars, learnerType, setOutfit, purchaseOutfit } = useOutfitState()

  const selectOutfit = (outfit: OutfitType) => {
    if (outfit === 'none' || ownedOutfits.includes(outfit)) {
      setOutfit(outfit)
      return
    }
    if (purchaseOutfit(outfit)) setOutfit(outfit)
  }

  return (
    <div className="pet-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="pet-wardrobe" role="dialog" aria-modal="true" aria-labelledby="pet-wardrobe-title" onMouseDown={(event) => event.stopPropagation()}>
        <header className="pet-wardrobe-header">
          <div>
            <span className="pet-wardrobe-kicker"><Shirt size={14} /> 奶油云团衣橱</span>
            <h2 id="pet-wardrobe-title">选择冒险伙伴的装扮</h2>
            <p>前测推荐路线的首套装扮免费，其余套装均为 25 星星。</p>
          </div>
          <div className="pet-wardrobe-actions">
            <span className="pet-star-balance"><Sparkles size={16} /> {stars}</span>
            <button className="pet-icon-button" type="button" onClick={onClose} aria-label="关闭衣橱"><X size={20} /></button>
          </div>
        </header>

        <div className="pet-outfit-grid">
          <button className={`pet-outfit-card ${currentOutfit === 'none' ? 'is-selected' : ''}`} type="button" onClick={() => selectOutfit('none')}>
            <span className="pet-outfit-preview pet-outfit-none">☁</span>
            <span className="pet-outfit-copy"><strong>原始云团</strong><small>轻装陪伴，不穿戴套装</small></span>
            {currentOutfit === 'none' && <Check className="pet-outfit-status" size={18} />}
          </button>

          {outfitConfigs.map((outfit) => {
            const owned = ownedOutfits.includes(outfit.id)
            const selected = currentOutfit === outfit.id
            const recommended = learnerType === outfit.learnerType
            return (
              <button
                className={`pet-outfit-card ${selected ? 'is-selected' : ''}`}
                style={{ '--outfit-accent': outfit.color } as React.CSSProperties}
                type="button"
                key={outfit.id}
                onClick={() => selectOutfit(outfit.id)}
              >
                <span className="pet-outfit-preview">
                  <cream-cloud-pet state="idle" size="68" outfit={outfit.id} />
                </span>
                <span className="pet-outfit-copy">
                  <span className="pet-outfit-title"><strong>{outfit.name}</strong>{recommended && <em>前测推荐</em>}</span>
                  <small>{outfit.path} · {outfit.description}</small>
                  {!owned && <span className="pet-outfit-price"><Sparkles size={13} /> 25 星星</span>}
                </span>
                {selected ? <Check className="pet-outfit-status" size={18} /> : !owned ? <LockKeyhole className="pet-outfit-status" size={17} /> : null}
              </button>
            )
          })}
        </div>
        <p className="pet-wardrobe-note">装扮只表达学习偏好，不改变能力层级、题目难度或动态评估结果。</p>
      </section>
    </div>
  )
}
